﻿import "bootstrap";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailBestellungPosition extends GuiDetailGeneric {

    constructor() {
        super("BestellPosition");
    }
}
